import Button from "components/atoms/Button";
import InputField from "components/atoms/InputField";
import InputSelect from "components/atoms/InputSelect";
import { useFormik } from "formik";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import BKK from "services/BKK";
import Wilayah from "services/Wilayah";
import { errorToastNotif } from "utils/common";
import {
  NumberOfMicroscopicTrainingOptions,
  PageMode,
  Source,
  UserLevel,
  YesAndNoOptions,
  RDTBrandOptions,
} from "utils/constant";
import React from "react";
import DataLabBKK from "services/DataLabBKK";

const WilayahService = new Wilayah();
const BKKService = new BKK();
const DataLabService = new DataLabBKK();

const FormComponent = ({ selectedItem, pageMode, handlePageModeChange }) => {
  const [urbanvillages, setUrbanvillages] = useState([]);

  const { currentUser } = useSelector((state) => state.authReducer);
  const [levelIdValue, setLevelIdValue] = useState("");
  const [levelDataOptions, setLevelDataOptions] = useState({
    provinces: [],
    districts: [],
    fasyankes: [],
  });

  const [selectedProvince, setSelectedProvince] = useState(
    currentUser?.province_id
  );
  const [selectedDistrict, setSelectedDistrict] = useState(
    currentUser?.district_id
  );
  const [selectedFasyankes, setSelectedFasyankes] = useState(
    currentUser?.username
  );

  const fetchAllProvincies = async () => {
    try {
      const response = await WilayahService.getAll(Source.PROVINCE, {
        page: 1,
        limit: 9999,
      });
      setLevelDataOptions((prevState) => ({
        ...prevState,
        provinces: response.province.map((item) => {
          return {
            label: item.name,
            value: `${item.id}|${item.name}`,
          };
        }),
      }));
    } catch (error) {
      console.log(error);
    }
  };

  const fetchDistrictByProvince = async (provinceId) => {
    try {
      const response = await WilayahService.getAll(Source.DISTRICT, {
        page: 1,
        limit: 9999,
        searchBy: "province_id",
        searchValue: provinceId,
      });

      setLevelDataOptions((prevState) => ({
        ...prevState,
        districts: response.district.map((item) => {
          return {
            label: item.name,
            value: `${item.id}|${item.name}`,
          };
        }),
      }));
    } catch (error) {
      console.log(error);
    }
  };

  const fetchFasyankesByDistrict = async (districtId) => {
    try {
      const response = await BKKService.getAll({
        searchBy: "id",
        searchValue: currentUser?.username,
        limit: 9999,
        page: 1,
        excludePkm: false,
      });

      setLevelDataOptions((prevState) => ({
        ...prevState,
        fasyankes: response.bkk.map((item) => {
          return {
            id: item.id,
            label: item.name,
            value: `${item.id}|${item.name}`,
          };
        }),
      }));
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    fetchAllProvincies();

    if (selectedProvince) {
      fetchDistrictByProvince(selectedProvince?.split("|")[0]);
    }
    if (selectedDistrict) {
      fetchFasyankesByDistrict(selectedDistrict?.split("|")[0]);
    }
  }, [selectedProvince, selectedDistrict]);

  const formik = useFormik({
    initialValues: {
      province_id: currentUser?.province_id,
      district_id: currentUser?.district_id,
      fasyankes_id: currentUser?.username,
      priksa_mikros: "",
      keg_prksa_rdt: "",
      jum_mikros_baik: "",
      spo_kaca_objek: "",
      spo_pmbtn_darah: "",
      spo_pwrn_darah: "",
      spo_pbcn_darah: "",
      spo_giemsa: "",
      spo_imersi: "",
      spo_methanol: "",
      spo_phbuffer: "",
      spo_pgunaan_prwtan_mikros: "",
      spo_k3malaria: "",
      spo_rdt: "",
      kd_rdt: "",
      merk_rdt_lain: "",
    },
    validate: (values) => {
      const errors = {};
      if (!values.priksa_mikros) {
        errors.priksa_mikros = "Pemeriksaan Mikroskopis wajib diisi";
      }
      if (
        formik.values.jum_mikros_baik === "" ||
        formik.values.jum_mikros_baik === null ||
        formik.values.jum_mikros_baik === undefined
      ) {
        errors.jum_mikros_baik = "Jumlah mikroskop keadaan baik wajib diisi";
      }

      if (values.priksa_mikros === "Ya") {
        if (!values.spo_kaca_objek) {
          errors.spo_kaca_objek =
            "SPO pembersihan dan penyimpanan kaca objek wajib diisi";
        }
        if (!values.spo_pmbtn_darah) {
          errors.spo_pmbtn_darah =
            "SPO pembuatan sediaan darah malaria wajib diisi";
        }
        if (!values.spo_pwrn_darah) {
          errors.spo_pwrn_darah =
            "SPO pewarnaan sediaan darah malaria wajib diisi";
        }
        if (!values.spo_pbcn_darah) {
          errors.spo_pbcn_darah =
            "SPO Pembacaan dan Pelaporan HasilSediaan Darah Malaria wajib diisi";
        }
        if (!values.spo_giemsa) {
          errors.spo_giemsa = "SPO uji kualitas giemsa wajib diisi";
        }
        if (!values.spo_imersi) {
          errors.spo_imersi = "SPO uji kualitas minyak imersi wajib diisi";
        }
        if (!values.spo_methanol) {
          errors.spo_methanol = "SPO uji kualitas methanol wajib diisi";
        }
        if (!values.spo_phbuffer) {
          errors.spo_phbuffer = "SPO Uji Kualitas Buffer pH wajib diisi";
        }
        if (!values.spo_pgunaan_prwtan_mikros) {
          errors.spo_pgunaan_prwtan_mikros =
            "SPO penggunaan dan perawatan mikroskop wajib diisi";
        }
        if (!values.spo_k3malaria) {
          errors.spo_k3malaria = "SPO Pelaksanaan K3 wajib diisi";
        }
      }

      if (!values.keg_prksa_rdt) {
        errors.keg_prksa_rdt = "Melaksanakan pemeriksaan RDT wajib diisi";
      }

      if (values.keg_prksa_rdt === "Ya") {
        if (!values.spo_rdt) {
          errors.spo_rdt = "SPO uji RDT wajib diisi";
        }
        if (!values.kd_rdt) {
          errors.kd_rdt = "Merek RDT yang digunakan wajib diisi";
        } else if (values.kd_rdt === "R04" && !values.merk_rdt_lain) {
          errors.merk_rdt_lain = "Merek RDT lainnya wajib diisi";
        }
      }

      return errors;
    },
    onSubmit: async (values) => {
      const payload = {
        kd_prop: currentUser?.province_id
          ? currentUser.province_id.split("|")[0]
          : "",
        kd_kab: currentUser?.district_id
          ? currentUser.district_id.split("|")[0]
          : "",
        kd_faskes: currentUser?.username,
        tgl_simpan: moment().format("YYYY-MM-DD"),
        priksa_mikros: values.priksa_mikros,
        keg_prksa_rdt: values.keg_prksa_rdt,
        jum_mikros_baik: values.jum_mikros_baik,
        spo_kaca_objek: values.spo_kaca_objek,
        spo_pmbtn_darah: values.spo_pmbtn_darah,
        spo_pwrn_darah: values.spo_pwrn_darah,
        spo_pbcn_darah: values.spo_pbcn_darah,
        spo_giemsa: values.spo_giemsa,
        spo_imersi: values.spo_imersi,
        spo_methanol: values.spo_methanol,
        spo_phbuffer: values.spo_phbuffer,
        spo_pgunaan_prwtan_mikros: values.spo_pgunaan_prwtan_mikros,
        spo_k3malaria: values.spo_k3malaria,
        spo_rdt: values.spo_rdt,
        kd_rdt: values.kd_rdt,
        merk_rdt_lain: values.merk_rdt_lain,
      };

      switch (pageMode) {
        case PageMode.add:
          await DataLabService.add(payload)
            .then((res) => {
              handlePageModeChange(PageMode.view);
              toast.success("Data Lab berhasil ditambahkan", {
                position: "top-center",
                autoClose: 5000,
                hideProgressBar: true,
                closeOnClick: true,
                pauseOnHover: true,
                theme: "colored",
                draggable: true,
              });
            })
            .catch((err) => {
              errorToastNotif(err);
            });
          break;
        case PageMode.edit:
          await DataLabService.update(payload, selectedItem?.kd_id)
            .then((res) => {
              handlePageModeChange(PageMode.view);
              toast.success("Data Lab berhasil diupdate", {
                position: "top-center",
                autoClose: 5000,
                hideProgressBar: true,
                closeOnClick: true,
                pauseOnHover: true,
                theme: "colored",
                draggable: true,
              });
            })
            .catch((err) => {
              console.log(err);
              errorToastNotif(err);
            });
          break;
      }
    },
  });

  const getUrbanvillagesByCurrentUser = async () => {
    try {
      const response = await WilayahService.getAll(Source.URBANVILLAGE, {
        searchBy: "subdistrict_id",
        searchValue: currentUser?.subdistrict_id?.split("|")[0],
        page: 1,
        limit: 9999,
      });
      setUrbanvillages(response.urbanvillage);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getUrbanvillagesByCurrentUser();
  }, []);

  useEffect(() => {
    if (pageMode === PageMode.edit) {
      formik.setValues({
        province_id: selectedItem.province_id,
        district_id: selectedItem.district_id,
        fasyankes_id: selectedItem.fasyankes_id,
        priksa_mikros: selectedItem.priksa_mikros,
        keg_prksa_rdt: selectedItem.keg_prksa_rdt,
        jum_mikros_baik: selectedItem.jum_mikros_baik,
        spo_kaca_objek: selectedItem.spo_kaca_objek,
        spo_pmbtn_darah: selectedItem.spo_pmbtn_darah,
        spo_pwrn_darah: selectedItem.spo_pwrn_darah,
        spo_pbcn_darah: selectedItem.spo_pbcn_darah,
        spo_giemsa: selectedItem.spo_giemsa,
        spo_imersi: selectedItem.spo_imersi,
        spo_methanol: selectedItem.spo_methanol,
        spo_phbuffer: selectedItem.spo_phbuffer,
        spo_pgunaan_prwtan_mikros: selectedItem.spo_pgunaan_prwtan_mikros,
        spo_k3malaria: selectedItem.spo_k3malaria,
        spo_rdt: selectedItem.spo_rdt,
        kd_rdt: selectedItem.kd_rdt,
        merk_rdt_lain: selectedItem.merk_rdt_lain,
      });
    }
  }, [selectedItem]);

  return (
    <>
      <h1 className="page-title">
        {pageMode === PageMode.add
          ? "Data Dasar Laboratorium Pemeriksaan Malaria - BKK"
          : "Edit Data Dasar Laboratorium Pemeriksaan Malaria - BKK"}
      </h1>

      <div className="form-grouping">
        <p
          className="warning"
          style={{ marginTop: "24px", marginBottom: "24px" }}
        >
          NOTE<span>*(WAJIB DIISI)</span>
        </p>

        <div className="row">
          <div className="col-sm-4 mb-3">
            <InputSelect
              isClearable={false}
              placeholder={"Pilih Provinsi"}
              data={levelDataOptions.provinces}
              onChange={(e) => {
                setSelectedProvince(e.value);
                setSelectedFasyankes("");
                setSelectedDistrict("");
              }}
              value={
                levelDataOptions.provinces?.find(
                  (item) => item.value === selectedProvince
                ) || ""
              }
              isDisabled={true}
            />
          </div>
          <div className="col-sm-4 mb-3">
            <InputSelect
              isClearable={false}
              placeholder={"Pilih Kab/Kota"}
              data={levelDataOptions.districts}
              onChange={(e) => {
                setSelectedDistrict(e.value);
                setSelectedFasyankes("");
              }}
              value={
                levelDataOptions.districts?.find(
                  (item) => item.value === selectedDistrict
                ) || ""
              }
              isDisabled={true}
            />
          </div>
          <div className="col-sm-4 mb-3">
            <InputSelect
              isClearable={false}
              isMultipleSelect={false}
              placeholder={"Pilih Wilker"}
              data={levelDataOptions.fasyankes}
              value={levelDataOptions.fasyankes[0]}
              isDisabled={true}
            />
          </div>
        </div>
        <div className="row">
          <div className="col-sm-4">
            <InputSelect
              label={"Pemeriksaan mikroskopis"}
              name={"priksa_mikros"}
              placeholder={"Pilih Pemeriksaan mikroskopis"}
              data={YesAndNoOptions}
              onChange={(e) => {
                const selectedValue = e?.value ?? "";
                formik.setFieldValue("priksa_mikros", selectedValue);
                if (selectedValue !== "Ya") {
                  formik.setFieldValue("spo_kaca_objek", "");
                  formik.setFieldValue("spo_pmbtn_darah", "");
                  formik.setFieldValue("spo_pwrn_darah", "");
                  formik.setFieldValue("spo_pbcn_darah", "");
                  formik.setFieldValue("spo_giemsa", "");
                  formik.setFieldValue("spo_imersi", "");
                  formik.setFieldValue("spo_methanol", "");
                  formik.setFieldValue("spo_phbuffer", "");
                  formik.setFieldValue("spo_pgunaan_prwtan_mikros", "");
                  formik.setFieldValue("spo_k3malaria", "");
                }
              }}
              onBlur={formik.handleBlur}
              value={YesAndNoOptions.find(
                (option) => option.value === formik.values.priksa_mikros
              )}
              error={
                formik.errors.priksa_mikros && formik.touched.priksa_mikros
              }
              errorMessage={formik.errors.priksa_mikros}
              isRequired={true}
            />
          </div>

          <div className="col-sm-4">
            <InputSelect
              label={"Melaksanakan pemeriksaan RDT"}
              name={"keg_prksa_rdt"}
              placeholder={"Pilih Melaksanakan pemeriksaan RDT"}
              data={YesAndNoOptions}
              onChange={(e) => {
                const selectedValue = e?.value ?? "";
                formik.setFieldValue("keg_prksa_rdt", selectedValue);
                if (selectedValue !== "Ya") {
                  formik.setFieldValue("spo_rdt", "");
                  formik.setFieldValue("kd_rdt", "");
                  formik.setFieldValue("merk_rdt_lain", "");
                }
              }}
              onBlur={formik.handleBlur}
              value={YesAndNoOptions.find(
                (option) => option.value === formik.values.keg_prksa_rdt
              )}
              error={
                formik.errors.keg_prksa_rdt && formik.touched.keg_prksa_rdt
              }
              errorMessage={formik.errors.keg_prksa_rdt}
              isRequired={true}
            />
          </div>

          <div className="col-sm-4">
            <InputSelect
              label={"Jumlah mikroskop keadaan baik"}
              name={"jum_mikros_baik"}
              placeholder={"Pilih Jumlah mikroskop keadaan baik"}
              data={NumberOfMicroscopicTrainingOptions}
              onChange={(e) => {
                const selectedValue = e?.value ?? "";
                formik.setFieldValue("jum_mikros_baik", selectedValue);
              }}
              onBlur={formik.handleBlur}
              value={NumberOfMicroscopicTrainingOptions.find(
                (option) => option.value === formik.values.jum_mikros_baik
              )}
              error={
                formik.errors.jum_mikros_baik && formik.touched.jum_mikros_baik
              }
              errorMessage={formik.errors.jum_mikros_baik}
              isRequired={true}
            />
          </div>
        </div>
        <hr />
        <h4 style={{ fontWeight: "bold" }}>
          Standar Prosedur Operasional (SPO)
        </h4>
        <div className="row">
          <div className="col-sm-6">
            <InputSelect
              label={"SPO pembersihan dan penyimpanan kaca objek"}
              name={"spo_kaca_objek"}
              placeholder={"Pilih SPO pembersihan dan penyimpanan kaca objek"}
              data={YesAndNoOptions}
              onChange={(e) => {
                const selectedValue = e?.value ?? "";
                formik.setFieldValue("spo_kaca_objek", selectedValue);
              }}
              onBlur={formik.handleBlur}
              value={YesAndNoOptions.find(
                (option) => option.value === formik.values.spo_kaca_objek
              )}
              error={
                formik.errors.spo_kaca_objek && formik.touched.spo_kaca_objek
              }
              errorMessage={formik.errors.spo_kaca_objek}
              disabled={formik.values.priksa_mikros !== "Ya"}
              isRequired={formik.values.priksa_mikros !== "Tidak"}
            />
          </div>
          <div className="col-sm-6">
            <InputSelect
              label={"SPO pembuatan sediaan darah malaria"}
              name={"spo_pmbtn_darah"}
              placeholder={"Pilih SPO pembuatan sediaan darah malaria"}
              data={YesAndNoOptions}
              onChange={(e) => {
                const selectedValue = e?.value ?? "";
                formik.setFieldValue("spo_pmbtn_darah", selectedValue);
              }}
              onBlur={formik.handleBlur}
              value={YesAndNoOptions.find(
                (option) => option.value === formik.values.spo_pmbtn_darah
              )}
              error={
                formik.errors.spo_pmbtn_darah && formik.touched.spo_pmbtn_darah
              }
              errorMessage={formik.errors.spo_pmbtn_darah}
              disabled={formik.values.priksa_mikros !== "Ya"}
              isRequired={formik.values.priksa_mikros !== "Tidak"}
            />
          </div>
        </div>
        <div className="row">
          <div className="col-sm-6">
            <InputSelect
              label={"SPO pewarnaan sediaan darah malaria"}
              name={"spo_pwrn_darah"}
              placeholder={"Pilih SPO pewarnaan sediaan darah malaria"}
              data={YesAndNoOptions}
              onChange={(e) => {
                const selectedValue = e?.value ?? "";
                formik.setFieldValue("spo_pwrn_darah", selectedValue);
              }}
              onBlur={formik.handleBlur}
              value={YesAndNoOptions.find(
                (option) => option.value === formik.values.spo_pwrn_darah
              )}
              error={
                formik.errors.spo_pwrn_darah && formik.touched.spo_pwrn_darah
              }
              errorMessage={formik.errors.spo_pwrn_darah}
              disabled={formik.values.priksa_mikros !== "Ya"}
              isRequired={formik.values.priksa_mikros !== "Tidak"}
            />
          </div>
          <div className="col-sm-6">
            <InputSelect
              label={"SPO pembacaan dan pelaporan hasil sediaan darah malaria"}
              name={"spo_pbcn_darah"}
              placeholder={
                "Pilih SPO pembacaan dan pelaporan hasil sediaan darah malaria"
              }
              data={YesAndNoOptions}
              onChange={(e) => {
                const selectedValue = e?.value ?? "";
                formik.setFieldValue("spo_pbcn_darah", selectedValue);
              }}
              onBlur={formik.handleBlur}
              value={YesAndNoOptions.find(
                (option) => option.value === formik.values.spo_pbcn_darah
              )}
              error={
                formik.errors.spo_pbcn_darah && formik.touched.spo_pbcn_darah
              }
              errorMessage={formik.errors.spo_pbcn_darah}
              disabled={formik.values.priksa_mikros !== "Ya"}
              isRequired={formik.values.priksa_mikros !== "Tidak"}
            />
          </div>
        </div>
        <div className="row">
          <div className="col-sm-6">
            <InputSelect
              label={"SPO uji kualitas giemsa"}
              name={"spo_giemsa"}
              placeholder={"Pilih SPO uji kualitas giemsa"}
              data={YesAndNoOptions}
              onChange={(e) => {
                const selectedValue = e?.value ?? "";
                formik.setFieldValue("spo_giemsa", selectedValue);
              }}
              onBlur={formik.handleBlur}
              value={YesAndNoOptions.find(
                (option) => option.value === formik.values.spo_giemsa
              )}
              error={formik.errors.spo_giemsa && formik.touched.spo_giemsa}
              errorMessage={formik.errors.spo_giemsa}
              disabled={formik.values.priksa_mikros !== "Ya"}
              isRequired={formik.values.priksa_mikros !== "Tidak"}
            />
          </div>
          <div className="col-sm-6">
            <InputSelect
              label={"SPO uji kualitas minyak imersi"}
              name={"spo_imersi"}
              placeholder={"Pilih SPO uji kualitas minyak imersi"}
              data={YesAndNoOptions}
              onChange={(e) => {
                const selectedValue = e?.value ?? "";
                formik.setFieldValue("spo_imersi", selectedValue);
              }}
              onBlur={formik.handleBlur}
              value={YesAndNoOptions.find(
                (option) => option.value === formik.values.spo_imersi
              )}
              error={formik.errors.spo_imersi && formik.touched.spo_imersi}
              errorMessage={formik.errors.spo_imersi}
              disabled={formik.values.priksa_mikros !== "Ya"}
              isRequired={formik.values.priksa_mikros !== "Tidak"}
            />
          </div>
        </div>
        <div className="row">
          <div className="col-sm-6">
            <InputSelect
              label={"SPO uji kualitas methanol"}
              name={"spo_methanol"}
              placeholder={"Pilih SPO uji kualitas methanol"}
              data={YesAndNoOptions}
              onChange={(e) => {
                const selectedValue = e?.value ?? "";
                formik.setFieldValue("spo_methanol", selectedValue);
              }}
              onBlur={formik.handleBlur}
              value={YesAndNoOptions.find(
                (option) => option.value === formik.values.spo_methanol
              )}
              error={formik.errors.spo_methanol && formik.touched.spo_methanol}
              errorMessage={formik.errors.spo_methanol}
              disabled={formik.values.priksa_mikros !== "Ya"}
              isRequired={formik.values.priksa_mikros !== "Tidak"}
            />
          </div>
          <div className="col-sm-6">
            <InputSelect
              label={"SPO uji kualitas pH buffer"}
              name={"spo_phbuffer"}
              placeholder={"Pilih SPO uji kualitas pH buffer"}
              data={YesAndNoOptions}
              onChange={(e) => {
                const selectedValue = e?.value ?? "";
                formik.setFieldValue("spo_phbuffer", selectedValue);
              }}
              onBlur={formik.handleBlur}
              value={YesAndNoOptions.find(
                (option) => option.value === formik.values.spo_phbuffer
              )}
              error={formik.errors.spo_phbuffer && formik.touched.spo_phbuffer}
              errorMessage={formik.errors.spo_phbuffer}
              disabled={formik.values.priksa_mikros !== "Ya"}
              isRequired={formik.values.priksa_mikros !== "Tidak"}
            />
          </div>
        </div>
        <div className="row">
          <div className="col-sm-6">
            <InputSelect
              label={"SPO penggunaan dan perawatan mikroskop"}
              name={"spo_pgunaan_prwtan_mikros"}
              placeholder={"Pilih SPO penggunaan dan perawatan mikroskop"}
              data={YesAndNoOptions}
              onChange={(e) => {
                const selectedValue = e?.value ?? "";
                formik.setFieldValue(
                  "spo_pgunaan_prwtan_mikros",
                  selectedValue
                );
              }}
              onBlur={formik.handleBlur}
              value={YesAndNoOptions.find(
                (option) =>
                  option.value === formik.values.spo_pgunaan_prwtan_mikros
              )}
              error={
                formik.errors.spo_pgunaan_prwtan_mikros &&
                formik.touched.spo_pgunaan_prwtan_mikros
              }
              errorMessage={formik.errors.spo_pgunaan_prwtan_mikros}
              disabled={formik.values.priksa_mikros !== "Ya"}
              isRequired={formik.values.priksa_mikros !== "Tidak"}
            />
          </div>
          <div className="col-sm-6">
            <InputSelect
              label={"SPO pelaksanaan K3 malaria"}
              name={"spo_k3malaria"}
              placeholder={"Pilih SPO pelaksanaan K3 malaria"}
              data={YesAndNoOptions}
              onChange={(e) => {
                const selectedValue = e?.value ?? "";
                formik.setFieldValue("spo_k3malaria", selectedValue);
              }}
              onBlur={formik.handleBlur}
              value={YesAndNoOptions.find(
                (option) => option.value === formik.values.spo_k3malaria
              )}
              error={
                formik.errors.spo_k3malaria && formik.touched.spo_k3malaria
              }
              errorMessage={formik.errors.spo_k3malaria}
              disabled={formik.values.priksa_mikros !== "Ya"}
              isRequired={formik.values.priksa_mikros !== "Tidak"}
            />
          </div>
        </div>
        <div className="row">
          <div className="col-sm-6">
            <InputSelect
              label={"SPO uji RDT"}
              name={"spo_rdt"}
              placeholder={"Pilih SPO uji RDT"}
              data={YesAndNoOptions}
              onChange={(e) => {
                const selectedValue = e?.value ?? "";
                formik.setFieldValue("spo_rdt", selectedValue);
              }}
              onBlur={formik.handleBlur}
              value={YesAndNoOptions.find(
                (option) => option.value === formik.values.spo_rdt
              )}
              error={formik.errors.spo_rdt && formik.touched.spo_rdt}
              errorMessage={formik.errors.spo_rdt}
              disabled={formik.values.keg_prksa_rdt !== "Ya"}
              isRequired={formik.values.keg_prksa_rdt !== "Tidak"}
            />
          </div>
          <div className="col-sm-6">
            <InputSelect
              label={"Merek RDT yang digunakan"}
              name={"kd_rdt"}
              placeholder={"Pilih Merek RDT yang digunakan"}
              data={RDTBrandOptions}
              onChange={(e) => {
                const selectedValue = e?.value ?? "";
                formik.setFieldValue("kd_rdt", selectedValue);
                if (selectedValue !== "R04") {
                  formik.setFieldValue("merk_rdt_lain", "");
                }
              }}
              onBlur={formik.handleBlur}
              value={RDTBrandOptions.find(
                (option) => option.value === formik.values.kd_rdt
              )}
              error={formik.errors.kd_rdt && formik.touched.kd_rdt}
              errorMessage={formik.errors.kd_rdt}
              disabled={formik.values.keg_prksa_rdt !== "Ya"}
              isRequired={formik.values.keg_prksa_rdt !== "Tidak"}
            />
          </div>
        </div>
        {formik.values.kd_rdt === "R04" && (
          <InputField
            label={"Sebutkan merek RDT lainnya"}
            name={"merk_rdt_lain"}
            placeholder={"Sebutkan merek RDT lainnya"}
            type={"text"}
            {...formik.getFieldProps("merk_rdt_lain")}
            error={formik.errors.merk_rdt_lain && formik.touched.merk_rdt_lain}
            errorMessage={formik.errors.merk_rdt_lain}
            value={formik.values.merk_rdt_lain}
            isRequired={true}
            disabled={formik.values.kd_rdt !== "R04"}
          />
        )}

        {/* Action button */}
        <div className="button_action">
          <Button
            variant={"tertiary"}
            size={"normal"}
            onClick={() => handlePageModeChange(PageMode.view)}
          >
            Batalkan
          </Button>
          <Button
            type={"submit"}
            variant={"primary"}
            size={"normal"}
            onClick={formik.handleSubmit}
            isDisabled={
              formik.isSubmitting ||
              !formik.values.priksa_mikros ||
              !formik.values.keg_prksa_rdt ||
              formik.values.jum_mikros_baik === "" ||
              formik.values.jum_mikros_baik === null ||
              formik.values.jum_mikros_baik === undefined
            }
          >
            {pageMode === PageMode.edit ? "Ubah Data" : "Simpan Data"}
          </Button>
        </div>
      </div>
    </>
  );
};

export default FormComponent;
